import { Navigate } from '@sorare/routing';
import { ANY_SPORT_ONBOARDING_TUTORIAL_INTRO } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const TutorialPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_ONBOARDING_TUTORIAL_INTRO)}
      replace
    />
  );
};
export default TutorialPage;
